import { getElements, ifSelectorExist } from "./utils";

export function practiceTypesCollapse() {
  const practiceTypesTitles = getElements(".practice-types-block-item");
  if (ifSelectorExist(practiceTypesTitles)) {
    practiceTypesTitles.forEach(function (item) {
      let title = item.querySelector(".practice-types-block-title");
      let list = item.querySelector(".practice-types-block-list");

      let maxHeight = list.scrollHeight + "px";
      list.style.maxHeight = maxHeight;

      title.addEventListener("click", function () {
        item.classList.toggle("close");
      });
    });
  }
}

export function faqCollapse() {
  const faqItems = getElements(".faq-block-item");
  if (ifSelectorExist(faqItems) && ifSelectorExist(faqItems[0])) {
    faqItems[0].classList.add("open");
    faqItems.forEach(function (item) {
      let title = item.querySelector(".faq-block-title");
      console.log(item);
      title.addEventListener("click", function () {
        item.classList.toggle("open");
      });
    });
  }
}
